import React, {Component} from 'react';
import ReactDOM from "react-dom";
import {Modal, ModalHeader, ModalBody} from 'reactstrap';

class YouTubeModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modal: false
        };

        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <React.Fragment>
                <img src='assets/img/youtube-01.svg' className="yt-image pt-4 pt-md-0" onClick={this.toggleModal} alt="youtube"/>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} centered={true} className='modal-lg'>
                    <ModalBody>
                        <embed width="100%" height="500px"
                               src="https://www.youtube.com/embed/tgbNymZ7vqY"/>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        );
    }
}

if (document.getElementById('youtubeVideo')) {
    let element = document.getElementById('youtubeVideo');
    ReactDOM.render(<YouTubeModal/>, element);
}


export default YouTubeModal;

